import storage from '@drivesally/sally-fw/lib/storage/localStorage';

export default storage('/sally/george/auth/token/app-tokens');
